import React, { useState, useRef, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
// import { FaSearch, FaSpinner, FaInfoCircle, FaToggleOn, FaToggleOff, FaPen, FaSyncAlt, FaPenSquare, FaTrash, FaTimesCircle } from "react-icons/fa";
import { FaSearch, FaSpinner, FaCheckCircle, FaToggleOn, FaToggleOff, FaBars, FaTrash, FaTimesCircle, FaFile, FaHistory, FaEdit, FaInfoCircle, FaSyncAlt } from "react-icons/fa";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import * as PartnerService from '../../Services/Partner/PartnerService'
import * as AttachmentService from '../../Services/Attachment/AttachmentService'
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import { store } from "../../Store/store";
import MHL_PartnerUserModalComponent from "./MHL_PartnerUserModalComponent";
import MHL_DocumentModalComponent from "../Document/MHL_DocumentModalComponent";
import CommonPagination from "../../Common/CommonPagination";
import * as CommonVariables from '../../Common/CommonVariables'
import CommonRightPanel from "../../Common/CommonRightPanel";
import { FaE } from "react-icons/fa6";
import { Loader2 } from "lucide-react";
import CommonConfirmationModal from "../../Common/CommonConfirmationModal";
import "./PartnerListComponent.css"

const PartnerListComponent = () => {
  const { register, handleSubmit, setValue, getValues, watch, formState: { errors }, reset, } = useForm();

  const isB2bAllowed = watch("Is_B2b_Registration_Allow");

  const { register: registerEdit, handleSubmit: handleSubmitEdit, reset: resetEdit, getValues: getValuesEdit, watch: watchEdit, formState: { errors: errorEditPartner } } = useForm();

  const isB2bAllowedEdit = watchEdit("Is_B2b_Registration_Allow");

  const [filteredPartnerList, setFilteredPartnerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedSearchPartner = useRef();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15); // Set number of items per page
  const [partnerUserModal, setPartnerUserModal] = useState(false)
  const [partnerDocumentModal, setPartnerDocumentModal] = useState(false)
  const [selectedPartnerDet, setSelectedPartnerDet] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [selectedPartnerForToggle, setSelectedPartnerForToggle] = useState(null);

  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentPartners = filteredPartnerList.slice(indexOfFirstUser, indexOfLastUser);

  const userInfo = store.getState();

  const selectedPartnerCode = useRef();
  const [newPartnerShow, setNewPartnerShow] = useState(false);
  const [newPartnerActiveTab, setNewPartnerActiveTab] = useState("partner_details");
  const [bulkUploadFile, setBulkUploadFile] = useState(null);
  const [bulkUploadLoading, setBulkUploadLoading] = useState(false);
  const [editPartnerShow, setEditPartnerShow] = useState(false);
  const [partnerExists, setPartnerExists] = useState(false);
  const [ShowCreditFeilds, setShowCreditFeilds] = useState(false);
  const [partnerDetails, setPartnerDetails] = useState([]);
  const [SFDCPartnerDetails, setSFDCPartnerDetails] = useState([]);
  const [hover, setHover] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [allPartners, setAllPartners] = useState([]);
  const [partnerCodeInput, setPartnerCodeInput] = useState("");

  // Resets data for Edit Modal
  useEffect(() => {
    if (editPartnerShow && partnerDetails?.Partnerid) {
      resetEdit({
        Partnerid: partnerDetails.Partnerid || "",
        Partner_Description: partnerDetails.Partner_Description || "",
        Pincode: partnerDetails.Pincode || "",
        Is_Parent: !!partnerDetails.Is_Parent,
        Is_B2b_Registration_Allow: !!partnerDetails.Is_B2b_Registration_Allow,
        Is_Avail_For_PrePrintedBarcode: !!partnerDetails.Is_Avail_For_PrePrintedBarcode,
        Is_Auto_VID_Generation: !!partnerDetails.Is_Auto_VID_Generation,
        Is_Disable_Mandate_Doc: !!partnerDetails.Is_Disable_Mandate_Doc,
      });
    }
  }, [editPartnerShow, partnerDetails, resetEdit]);

  // Function to handle search
  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    setCurrentPage(1); // Reset to first page when searching

    if (!searchValue.trim()) {
      // If search is empty, show all partners
      setFilteredPartnerList(allPartners);
      return;
    }

    const filtered = allPartners.filter(partner => {
      const searchLower = searchValue.toLowerCase();

      return (
        partner.Partner_Name?.toLowerCase().includes(searchLower) ||
        partner.Partner_Code?.toLowerCase().includes(searchLower) ||
        partner.Payment_Type?.toLowerCase().includes(searchLower)
      );
    });

    setFilteredPartnerList(filtered);
  };

  const fetchPartnerList = useCallback(() => {
    PartnerService.GetPartnerList("")
      .then(({ data }) => {
        if (data.IsSuccess) {
          setAllPartners(data.Data);
          setFilteredPartnerList(data.Data);
        }
        else {
          setFilteredPartnerList([])
        }
      })
      .catch(() => toast.error("Something went wrong."));
  }, []);

  useEffect(() => {
    fetchPartnerList();
  }, [fetchPartnerList]);

  const fetchUniversalFilterPartnerData = () => {

    if (!selectedSearchPartner.current.value) {
      window.location.reload()
      return;
    }
    PartnerService.GetPartnerList(selectedSearchPartner.current.value)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredPartnerList(data.Data);
        }
        else {
          setFilteredPartnerList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."));
  };



  const searchPartnerCodeIfExist = () => {

    //debugger;
    // if (!selectedPartnerCode.current.value) {
    //   toast.error("No partner entered to search.")
    //   return;
    // }
    if (!partnerCodeInput.trim()) {
      toast.error("No partner entered to search.")
      return;
    }
    // reset();
    // PartnerService.ValidatePartnerExist(selectedPartnerCode.current.value)
    PartnerService.ValidatePartnerExist(partnerCodeInput)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setPartnerExists(true);
          setPartnerDetails(data.Data.DB_Account);
          setSFDCPartnerDetails(data.Data.SFDC_Account);

          setValue("Partnerid", data.Data.DB_Account.Partnerid || "");
          setValue("Ref_Partnerid", data.Data.DB_Account.Ref_Partnerid || "");
          setValue("Partner_Name", data.Data.DB_Account.Partner_Name || "");
          setValue("Payment_Type", data.Data.DB_Account.Payment_Type || "");
          setValue("Account_Record_Type", data.Data.DB_Account.Account_Record_Type || "");
          setValue("Emailid", data.Data.DB_Account.Emailid || "");
          setValue("Mobile_No", data.Data.DB_Account.Mobile_No || "");
          setValue("Credit_Days", data.Data.DB_Account.Credit_Days || "");
          setValue("Credit_Limit", data.Data.DB_Account.Credit_Limit || "");
          setValue("Partner_Description", data.Data.DB_Account.Partner_Description || "");
          setValue("Pincode", data.Data.DB_Account.Pincode || "");
          setValue("Is_Parent", data.Data.DB_Account.Is_Parent || "");
          setValue("Is_Avail_For_PrePrintedBarcode", data.Data.DB_Account.Is_Avail_For_PrePrintedBarcode || "");
          setValue("Partner_Code", data.Data.DB_Account.Partner_Code || "");
          setValue("Business_Type", data.Data.DB_Account.Business_Type || "");
          setValue("Is_Avail_Partner", !!data.Data.DB_Account.Is_Avail_Partner);
          setValue("Ad_Id", data.Data.DB_Account.Ad_Id || "");

          setValue("Nature_Of_Entity", data.Data.DB_Account.Nature_Of_Entity || "");
          setValue("Currency", data.Data.DB_Account.Currency || "");
          setValue("Is_B2b_Registration_Allow", data.Data.DB_Account.Is_B2b_Registration_Allow || "");
          setValue("Is_Auto_VID_Generation", data.Data.DB_Account.Is_Auto_VID_Generation || "");
          setValue("Is_Disable_Mandate_Doc", data.Data.DB_Account.Is_Disable_Mandate_Doc || "");
          setValue("Primary_Org", data.Data.DB_Account.Primary_Org || "");
          setValue("Org_SBU", data.Data.DB_Account.Org_SBU || "");
          setValue("Tag_Name", data.Data.DB_Account.Tag_Name || "");
        }
        else {
          toast.error("No Account find")
          reset();
          setPartnerDetails([]);
          setSFDCPartnerDetails([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => { setPartnerExists(false); });
  };

  const handleDownloadBulkPartnerTemplate = () => {
    PartnerService.DownloadBulkPartnerTemplate()
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "PartnerBulkUploadTemplate.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => toast.error("Failed to download template."));
  };

  const handleBulkUpload = () => {
    if (!bulkUploadFile) { toast.error("Please select an Excel file to upload."); return; }
    const formData = new FormData();
    formData.append("Myfile", bulkUploadFile);
    setBulkUploadLoading(true);
    PartnerService.BulkPartnerStaffOnboard(formData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          toast.success(data.ResponseMessage || "Bulk upload successful.");
          if (data.Data) {
            const link = document.createElement("a");
            link.href = data.Data;
            link.download = data.Data.split("/").pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          setBulkUploadFile(null);
          setNewPartnerShow(false);
          setNewPartnerActiveTab("partner_details");
        } else {
          toast.error(data.ResponseMessage || "Bulk upload failed.");
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setBulkUploadLoading(false));
  };

  const handlePartner = () => {
    //debugger;
    const allValues = getValues();

    allValues.Is_Parent = allValues.Is_Parent ? true : false;
    allValues.Is_B2b_Registration_Allow = allValues.Is_B2b_Registration_Allow ? true : false;
    allValues.Is_Avail_For_PrePrintedBarcode = allValues.Is_B2b_Registration_Allow ? !!allValues.Is_Avail_For_PrePrintedBarcode : false;
    allValues.Is_Auto_VID_Generation = allValues.Is_B2b_Registration_Allow ? !!allValues.Is_Auto_VID_Generation : false;
    allValues.Is_Disable_Mandate_Doc = allValues.Is_B2b_Registration_Allow ? !!allValues.Is_Disable_Mandate_Doc : false;

    if (allValues.Partnerid == "0") {
      PartnerService.CreatePartner(allValues).then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          reset();
          setPartnerCodeInput("");
          fetchPartnerList();
          setNewPartnerShow(false);
          toast.success("Partner created Successfully")
        } else {
          toast.error(data.ResponseMessage)
        }
      })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => { setLoading(false); setSFDCPartnerDetails(); });
    }
    else {
      PartnerService.UpdatePartner(allValues).then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          reset();
          setPartnerCodeInput("");
          fetchPartnerList();
          setNewPartnerShow(false);
          toast.success("Partner Updated Successfully")
        } else {
          toast.error("Something went wrong")
        }
      })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => { setLoading(false); setSFDCPartnerDetails(); });
    }
  }

  const handleEditPartner = (data) => {

    setLoading(true)

    data.Is_B2b_Registration_Allow = data.Is_B2b_Registration_Allow ? true : false;
    data.Is_Avail_For_PrePrintedBarcode = data.Is_B2b_Registration_Allow ? !!data.Is_Avail_For_PrePrintedBarcode : false;
    data.Is_Auto_VID_Generation = data.Is_B2b_Registration_Allow ? !!data.Is_Auto_VID_Generation : false;
    data.Is_Disable_Mandate_Doc = data.Is_B2b_Registration_Allow ? !!data.Is_Disable_Mandate_Doc : false;

    PartnerService.EditPartner(data)
      .then(({ data }) => {
        if (data.IsSuccess) {
          fetchPartnerList();
          setEditPartnerShow(false);
          resetEdit();
          setPartnerDetails([])
          toast.success(data.ResponseMessage);
        }
        else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false))
  }

  const UploadPartnerLogoToS3 = (fileList) => {
    //debugger;
    const file = fileList[0];
    if (file.size <= 1024 * 1024) {
      if (fileList != null && fileList.length > 0) {
        var formdata = new FormData();
        formdata.append("Myfile", fileList[0]);

        AttachmentService.FileUploadToS3(formdata)
          .then((response) => {
            if (response.data.IsSuccess) {
              toast.success(response.data.ResponseMessage);

            } else {
              toast.error(response.data.ResponseMessage);
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      } else {
        toast.error("Please choose Image First!");
      }
    } else {
      toast.error("File size exceeds 1MB.");
    }
  };


  // const handleActivateDeActivatePartner = (rec) => {

  //   PartnerService.ActivateDeactivatePartner(rec.Partnerid, rec.Ref_Partnerid, !rec.Isactive).then(data => {
  //     if (data.data.IsSuccess) {
  //       const message = rec.Isactive ? "Partner DeActivated Successfully" : "Partner Activated Successfully";
  //       toast.success(message);
  //       fetchPartnerList();
  //     } else {
  //       toast.error("Somthing went wrong");
  //     }
  //   }).catch(error => {
  //     toast.error("Somthing went wrong");
  //   })

  // };

  const handleConfirmToggle = () => {
    setModalLoader(true);
    PartnerService.ActivateDeactivatePartner(selectedPartnerForToggle.Partnerid, selectedPartnerForToggle.Ref_Partnerid, !selectedPartnerForToggle.Isactive)
      .then(data => {
        if (data.data.IsSuccess) {
          const message = selectedPartnerForToggle.Isactive ? "Partner DeActivated Successfully" : "Partner Activated Successfully";
          toast.success(message);
          fetchPartnerList();
          setShowConfirmationModal(false);
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch(error => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        setModalLoader(false);
      });
  };

  const handleToggleClick = (rec) => {
    setSelectedPartnerForToggle(rec);
    setShowConfirmationModal(true);
  };

  const handleEditPartnerUserDetails = (rec) => {
    setSelectedPartnerDet(rec);
    setPartnerUserModal(true);
  }

  const handleEditPartnerDocuments = (rec) => {
    setSelectedPartnerDet(rec);
    setPartnerDocumentModal(true);
  }

  const handleNewPartnerUserClose = () => {
    reset();
    setPartnerUserModal(false)
    setPartnerDocumentModal(false);
    setSelectedPartnerDet([]);
  };

  const handleNewDocumentModalClose = () => {
    reset();
    setPartnerUserModal(false)
    setPartnerDocumentModal(false);
    setSelectedPartnerDet([]);
  };

  const [showRightPanel, setShowRightPanel] = useState(false);
  const [staffLoginHistory, setStaffLoginHistory] = useState([]);

  const fetchPartner_StaffLoginHistory = (partner_code) => {
    reset();
    PartnerService.GetPartner_StaffLoginHistory(partner_code)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setStaffLoginHistory(data.Data)
          setShowRightPanel(true);
        } else {
          setStaffLoginHistory([]);
        }
      })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  }

  const handleShowLoginLog = (rec) => {
    // //console.log(rec.Partner_Code);
    fetchPartner_StaffLoginHistory(rec.Partner_Code);
  }


  return (
    <>
      {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
      <CommonContainer heading="Partner List" buttonText="Add Partner" onButtonClick={() => { setNewPartnerShow(true); reset(); setSFDCPartnerDetails([]); setPartnerDetails([]) }}>

        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center gap-2">
          </div>
          <div className="search-box" style={{ position: "relative", width: "320px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Partner Code, Name, Payment Type"
              ref={selectedSearchPartner}
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              style={{
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
            />
            <button
              type="button"
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
              style={{
                padding: '5px',
                position: "absolute",
                right: "0px",
                height: "35px",
                width: "45px",
                top: "50%",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
                transform: "translateY(-50%)",
              }}
              // onClick={fetchUniversalFilterPartnerData}
              onClick={() => handleSearch(searchTerm)}
            >
              <FaSearch />
            </button>

          </div>

        </div>
        <div>
          <div className="table-responsive" >
            <table className="table table-bordered custom-table" >
              <thead>
                <tr>
                  <th style={{ width: '25%' }}> Name </th>
                  <th style={{ width: '7%' }}> Code </th>
                  <th style={{ width: '20%' }}> Email Id </th>
                  <th style={{ width: '7%' }}> Mobile No </th>
                  <th style={{ width: '7%' }}> Account Type</th>
                  {/* <th style={{ width: '11%' }}> Payment Type</th> */}
                  <th style={{ width: '6%' }}> Primary Org</th>
                  <th style={{ width: '5%' }}> Org SBU</th>
                  <th style={{ width: '10%' }}> Business Type</th>
                  <th style={{ width: '5%' }}> Active </th>
                  <th style={{ width: '6%' }}> Action </th>
                </tr>
              </thead>
              <tbody className="patient-list-small-font">
                {
                  currentPartners.length > 0 ? (
                    currentPartners.map((rec, index) => (
                      <tr key={index} className="partner-list-row">
                        {/* <td>{rec.Partner_Name} </td > */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          {rec.Payment_Type === "Rolling Advance" && (
                            <><i className="fas fa-battery-full text-success me-1" title="Rolling Advance" /> </>
                          )}
                          {rec.Payment_Type === "Credit" && (
                            <><i className="fas fa-credit-card text-success me-1" title="Credit" /> </>
                          )}
                          {rec.Payment_Type === "Cash" && (
                            <><i className="fas fa-money-bill-wave text-warning me-1" title="Cash" /></>
                          )}
                          {rec.Partner_Name}
                          {rec.Is_B2b_Registration_Allow && (
                            <FaCheckCircle className="text-success ms-1" title="B2B Registration Enabled" style={{ verticalAlign: "text-top",cursor: "" }} fontSize={12} />
                          )}
                        </td>

                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Partner_Code} </td>
                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}> </td> */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Emailid} </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Mobile_No} </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Account_Record_Type} </td>
                        {/* <td> {rec.Payment_Type} </td> */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Primary_Org || '-'} </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Org_SBU || '-'} </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Business_Type} </td>
                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          {rec.Isactive ? <FaToggleOn className="cursor-pointer" title="Deactivate Partner" onClick={() => handleActivateDeActivatePartner(rec)} color="green" size={16} /> : <FaToggleOff className="cursor-pointer" onClick={() => handleActivateDeActivatePartner(rec)} title="Activate Partner" color="red" size={16} />}
                        </td> */}
                        <td >
                          {rec.Isactive ? 
                            <FaToggleOn
                              className="cursor-pointer"
                              title="Deactivate Partner"
                              onClick={() => handleToggleClick(rec)}
                              color="green"
                              size={16}
                            /> 
                            : 
                            <FaToggleOff
                              className="cursor-pointer"
                              title="Activate Partner"
                              onClick={() => handleToggleClick(rec)}
                              color="red"
                              size={16}
                            />
                          }
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <div className="d-flex gap-2 justify-content-center">
                            <FaBars color="green" style={{ cursor: "pointer" }} onClick={() => handleEditPartnerUserDetails(rec)} title="Edit Partner Staff" />
                            <FaHistory color="green" style={{ cursor: "pointer" }} onClick={() => handleShowLoginLog(rec)} title="Staff Login Logs" />
                            {/* <FaEdit color="green" style={{cursor: "pointer"}} onClick={()=>{setEditPartnerShow(true); selectedPartnerDet(rec)}} title="Edit Partner Details" /> */}
                            <FaEdit color="green" style={{ cursor: "pointer" }} onClick={() => { setEditPartnerShow(true); setPartnerDetails(rec) }} title="Edit Partner Details" />

                          </div>
                          {/* <FaFile color="green" className="mr-2 cursor-pointer" onClick={() => handleEditPartnerDocuments(rec)} title="Edit Partner Staff" /> */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="9" className="text-center" > No Partner found </td></tr >
                  )}
              </tbody>
            </table>
          </div>

          {
            filteredPartnerList.length > itemsPerPage ? (
              <CommonPagination
                pageList={filteredPartnerList}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
              />
            ) : null}

        </div>
        {newPartnerShow && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg custom-modal" role="document" style={{ maxHeight: "600px" }}>
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2">
                    <h5 className="modal-title">New Partner</h5>
                    <button type="button" disabled={loading} className="btn-close pr-4"
                      onClick={() => { setNewPartnerShow(false); reset(); setPartnerDetails([]); setPartnerCodeInput(""); setNewPartnerActiveTab("partner_details"); setBulkUploadFile(null); }}>
                    </button>
                  </div>
                  <div className="modal-body p-1">
                    {/* Tab Nav */}
                    <div className="d-flex border-bottom mb-2">
                      {["partner_details", "bulk_upload"].map((tab) => (
                        <button
                          key={tab}
                          type="button"
                          onClick={() => setNewPartnerActiveTab(tab)}
                          className="btn"
                          style={{
                            borderRadius: 0,
                            borderBottom: newPartnerActiveTab === tab ? "3px solid #198754" : "3px solid transparent",
                            color: newPartnerActiveTab === tab ? "#198754" : "#6c757d",
                            fontWeight: newPartnerActiveTab === tab ? "600" : "400",
                            padding: "6px 16px",
                            fontSize: "13px",
                          }}
                        >
                          {tab === "partner_details" ? "Partner Details" : "Bulk Upload"}
                        </button>
                      ))}
                    </div>

                    <form onSubmit={handleSubmit(handlePartner)} style={{ display: newPartnerActiveTab === "partner_details" ? "" : "none" }}>
                      <div className="container m-0 p-1">
                        {/* Partner Code, Name, Payment Type */}
                        <div className="row mb-4 align-items-center">
                          <div className="col-md-4">
                            <label className="fw-bold required mb-0-5">Partner Code</label>
                            {/* <div style={{ position: "relative", width: "320px" }}> */}
                            <div style={{ position: "relative" }}>
                              <input
                                type="text"
                                className="form-control uppercase-text" placeholder="Enter Partner code"
                                ref={selectedPartnerCode}
                                value={partnerCodeInput}
                                style={{ paddingRight: "35px", borderRadius: "5px", border: "1px solid #ddd" }}
                                onChange={(e) => setPartnerCodeInput(e.target.value.toUpperCase())}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    searchPartnerCodeIfExist();
                                  }
                                }}
                              />
                              <button
                                type="button"
                                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
                                style={{
                                  padding: '5px',
                                  position: "absolute",
                                  right: "0px",
                                  height: "35px",
                                  width: "45px",
                                  top: "50%",
                                  borderTopLeftRadius: "0",
                                  borderBottomLeftRadius: "0",
                                  transform: "translateY(-50%)",
                                }}
                                onClick={searchPartnerCodeIfExist}>
                                <FaSearch />
                              </button>
                            </div>
                            {errors.Partner_Code && <small className="text-danger">{errors.Partner_Code.message}</small>}
                          </div>

                          <input type="hidden" {...register("Partnerid")} />
                          <input type="hidden" {...register("Ref_Partnerid")} />
                          {/* <input type="hidden" {...register("Partner_Code")} /> */}
                          <input type="hidden" {...register("Business_Type")} />
                          <input type="hidden" {...register("Is_Avail_Partner")} />
                          <input type="hidden" {...register("Nature_Of_Entity")} />
                          {/* <input type="hidden" {...register("Account_Record_Type")} /> */}
                          <input type="hidden" {...register("Currency")} />
                          <input type="hidden" {...register("Ad_Id")} />
                          <input type="hidden" {...register("Primary_Org")} />
                          <input type="hidden" {...register("Org_SBU")} />
                          <input type="hidden" {...register("Tag_Name")} />

                          <div className="col-md-4">
                            <label className="fw-bold mb-0-5">Partner Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Partner Name"
                              {...register("Partner_Name")}
                              value={partnerDetails.Partner_Name} />
                          </div>

                          <div className="col-md-4">
                            <label className="fw-bold mb-0-5">Payment Type</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Payment Type"
                              {...register("Payment_Type")}
                              value={partnerDetails.Payment_Type} />
                          </div>
                        </div>

                        <div className="row">

                          <div className="col-md-4 mb-3">
                            <label className="fw-bold mb-0-5">Account Record Type</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Account Record Type"
                              {...register("Account_Record_Type")}
                              value={partnerDetails.Account_Record_Type} />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="fw-bold mb-0-5">Email</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              {...register("Emailid")}
                              value={partnerDetails.Emailid} />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="fw-bold mb-0-5">Mobile No</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Mobile No"
                              {...register("Mobile_No", { required: "Mobile No is required" })}
                              value={partnerDetails.Mobile_No} />
                          </div>

                          {/* Credit Fields */}
                          {partnerDetails.Payment_Type == "Credit" && (
                            <>
                              <div className="col-md-4 mb-3">
                                <label className="fw-bold mb-0-5">Credit Days</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Credit Days"
                                  {...register("Credit_Days")}
                                  value={partnerDetails.Credit_Days} />

                              </div>

                              <div className="col-md-4 mb-3">
                                <label className="fw-bold mb-0-5">Credit Limit</label>
                                <input
                                  type="text"
                                  placeholder="Credit Limit"
                                  className="form-control"
                                  {...register("Credit_Limit")}
                                  value={partnerDetails.Credit_Limit} />
                              </div>
                            </>
                          )}
                        </div>

                        {/* Description and Logo */}
                        <div className="row">
                          <div className="col-md-8 mb-3">
                            <label className="fw-bold mb-0-5">Partner Description</label>
                            <textarea
                              className="form-control"
                              rows="3"
                              {...register("Partner_Description")}
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="fw-bold mb-0-5">Pincode</label>

                            <input
                              className="form-control"
                              placeholder="Pincode"
                              maxLength={6}
                              {...register("Pincode", {
                                validate: (value) => {
                                  if (!value) return true; // optional

                                  if (!/^[1-9]\d{5}$/.test(value)) {
                                    return "Enter a valid 6-digit pincode";
                                  }

                                  return true;
                                }
                              })}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, '');
                              }}
                            />

                            {errors?.Pincode && (
                              <small className="text-danger">
                                {errors.Pincode.message}
                              </small>
                            )}
                          </div>


                          {/* Is_Parent & Is available for pre printed barcode */}
                          <div className="col-md-12 d-flex flex-wrap gap-2 mt-4 mb-3">
                            <div className="form-check partner-check">
                              <input type="checkbox" className="form-check-input" {...register("Is_Parent")} />
                              <label className="form-check-label fw-bold">Is Parent</label>
                            </div>
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" {...register("Is_B2b_Registration_Allow")} />
                              <label className="form-check-label fw-bold partner-check-label">
                                B2b Registration Allowed
                                <FaInfoCircle title="Enables self-registration for partners like labs/hospitals after agreement." color="green" size={10} className="partner-label-info" />
                              </label>
                            </div>
                            {isB2bAllowed && (
                              <>
                                <div className="form-check partner-check">
                                  <input type="checkbox" className="form-check-input" {...register("Is_Avail_For_PrePrintedBarcode")} />
                                  <label className="form-check-label fw-bold partner-check-label">
                                    Available For Pre Printed Barcode
                                    <FaInfoCircle title="Enable only when pre-printed barcode containers are provided to the partner." color="green" size={10} className="partner-label-info" />
                                  </label>
                                </div>
                                <div className="form-check partner-check">
                                  <input type="checkbox" className="form-check-input" {...register("Is_Auto_VID_Generation")} />
                                  <label className="form-check-label fw-bold partner-check-label">
                                    Auto VID Generation
                                    <FaInfoCircle title="Automatically generates VID after partner completes self-registration (don't enable without approval)." color="green" size={10} className="partner-label-info" />
                                  </label>
                                </div>
                                <div className="form-check partner-check">
                                  <input type="checkbox" className="form-check-input" {...register("Is_Disable_Mandate_Doc")} />
                                  <label className="form-check-label fw-bold partner-check-label">
                                    Disable Mandatory Documents
                                    <FaInfoCircle title="Skips mandatory document requirement for tests." color="green" size={10} className="partner-label-info" />
                                  </label>
                                </div>
                              </>
                            )}
                          </div>

                          {/* <div className="col-md-4 mb-3">
                          <label className="fw-bold mb-0-5">Partner Logo</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => UploadPartnerLogoToS3(e.target.files)}
                            multiple={false}
                            accept="image/png"
                            {...register("Partner_Logo")}
                          />
                          {errors.Partner_Logo && <small className="text-danger">{errors.Partner_Logo.message}</small>}
                        </div> */}
                        </div>



                        {/* Modal Footer */}
                        <div className="modal-footer p-1">
                          <button
                            type="button"
                            disabled={loading}
                            className="btn btn-danger "
                            onClick={() => { setNewPartnerShow(false); reset(); setPartnerDetails([]); setPartnerCodeInput("") }}
                          >
                            Close
                          </button>
                          <button type="submit" disabled={loading} className="btn btn-success" >
                            Save
                          </button>
                        </div>
                      </div>

                    </form>

                    {/* Bulk Upload Tab */}
                    {newPartnerActiveTab === "bulk_upload" && (
                      <div className="p-2">
                        <div className="row g-3">
                          <div className="col-12 col-md-7">
                            <label className="fw-bold required mb-1">Upload Excel File</label>
                            <div className="d-flex align-items-center gap-2">
                              <input
                                id="bulkUploadInput"
                                type="file"
                                className="form-control"
                                accept=".xlsx,.xls,.csv"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (!file) { setBulkUploadFile(null); return; }
                                  const ext = file.name.split(".").pop().toLowerCase();
                                  if (ext !== "xlsx" && ext !== "xls" && ext !== "csv") {
                                    toast.error("Only Excel or CSV files (.xlsx, .xls, .csv) are allowed.");
                                    e.target.value = "";
                                    setBulkUploadFile(null);
                                    return;
                                  }
                                  setBulkUploadFile(file);
                                }}
                              />
                              {bulkUploadFile && (
                                <FaTimesCircle
                                  size={18}
                                  color="#dc3545"
                                  style={{ cursor: "pointer", flexShrink: 0 }}
                                  title="Clear file"
                                  onClick={() => { setBulkUploadFile(null); document.getElementById("bulkUploadInput").value = ""; }}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-5">
                            <div
                              style={{
                                background: "#e8f4fd",
                                border: "1px solid #b8d9f0",
                                borderRadius: "6px",
                                padding: "8px 12px",
                                fontSize: "12px",
                                color: "#444",
                                lineHeight: "1.6",
                              }}
                            >
                              <strong>Note:</strong> Upload a valid Excel or CSV file.<br />
                              Accepted formats: <strong>.xlsx, .xls, .csv</strong><br /><br />
                              <button
                                type="button"
                                className="btn custom-sumbitbtn btn-sm w-100"
                                style={{ fontSize: "12px" }}
                                onClick={handleDownloadBulkPartnerTemplate}
                              >
                                Download Template
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mt-3 gap-2">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => { setNewPartnerShow(false); setNewPartnerActiveTab("partner_details"); setBulkUploadFile(null); }}
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            className="btn btn-success"
                            disabled={bulkUploadLoading || !bulkUploadFile}
                            onClick={handleBulkUpload}
                          >
                            {bulkUploadLoading ? <FaSpinner className="fa-spin me-1" /> : null}
                            Upload
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div >
        )}

        {editPartnerShow && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-md" role="document" style={{ maxHeight: "600px" }}>
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2">
                    <h5 className="modal-title">Edit Partner - {partnerDetails.Partner_Code} </h5>
                    <button type="button" disabled={loading} className="btn-close pr-4"
                      onClick={() => { setEditPartnerShow(false); resetEdit(); setPartnerDetails([]); }}>
                    </button>
                  </div>
                  <div className="modal-body p-1" style={{ maxHeight: "600px" }}>
                    <form onSubmit={handleSubmitEdit(handleEditPartner)}>
                      <div className="container m-0 p-1">
                        {/* Partner Code, Name, Payment Type */}
                        <div className="row align-items-center">
                          <div className="col-md-12 mb-2">
                            <label className="fw-bold mb-1">Partner Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Partner Name"
                              disabled
                              // {...register("Partner_Name")}
                              value={partnerDetails.Partner_Name} />
                          </div>

                          <input type="hidden" value={partnerDetails.Partnerid} {...registerEdit("Partnerid")} />

                          <div className="col-md-12 mb-2">
                            <label className="fw-bold mb-1">Pincode</label>

                            <input
                              className="form-control"
                              placeholder="Pincode"
                              {...registerEdit("Pincode", {
                                validate: (value) => {
                                  if (!value) return true; // not mandatory

                                  if (!/^\d{6}$/.test(value)) {
                                    return "Pincode must be exactly 6 digits";
                                  }

                                  if (value.startsWith("0")) {
                                    return "Pincode cannot start with 0";
                                  }

                                  if (value === "000000") {
                                    return "Invalid pincode";
                                  }

                                  return true;
                                }
                              })}
                              maxLength={6}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, '');
                              }}
                            />

                            {errorEditPartner?.Pincode && (
                              <small className="text-danger">
                                {errorEditPartner.Pincode.message}
                              </small>
                            )}
                          </div>


                        </div>

                        {/* Description and Logo */}
                        <div className="row">
                          <div className="col-md-12 mb-2">
                            <label className="fw-bold mb-0-5">Partner Description</label>
                            <textarea
                              className="form-control"
                              rows="3"
                              {...registerEdit("Partner_Description")}
                            />
                          </div>
                        </div>

                        <div className="row my-2">
                          {/* Is_Parent & Is available for pre printed barcode */}
                          <div className="d-flex flex-wrap gap-3">
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" {...registerEdit("Is_Parent")} />
                              <label className="form-check-label fw-bold">Is Parent</label>
                            </div>
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" {...registerEdit("Is_B2b_Registration_Allow")} defaultChecked={partnerDetails?.Is_B2b_Registration_Allow ? true : false} />
                              <label className="form-check-label fw-bold partner-check-label">
                                B2b Registration Allowed
                                <FaInfoCircle title="Enables self-registration for partners like labs/hospitals after agreement." color="green" size={10} className="partner-label-info" />
                              </label>
                            </div>
                            {isB2bAllowedEdit && (
                              <>
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...registerEdit("Is_Avail_For_PrePrintedBarcode")} />
                                  <label className="form-check-label fw-bold partner-check-label">
                                    Is Available For Pre Printed Barcode
                                    <FaInfoCircle title="Enable only when pre-printed barcode containers are provided to the partner." color="green" size={10} className="partner-label-info" />
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...registerEdit("Is_Auto_VID_Generation")} defaultChecked={partnerDetails?.Is_Auto_VID_Generation ? true : false} />
                                  <label className="form-check-label fw-bold partner-check-label">
                                    Auto VID Generation
                                    <FaInfoCircle title="Automatically generates a Visit ID for each partner registration." color="green" size={10} className="partner-label-info" />
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...registerEdit("Is_Disable_Mandate_Doc")} defaultChecked={partnerDetails?.Is_Disable_Mandate_Doc ? true : false} />
                                  <label className="form-check-label fw-bold partner-check-label">
                                    Disable Mandatory Documents
                                    <FaInfoCircle title="Skips mandatory document validation during partner registration." color="green" size={10} className="partner-label-info" />
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer p-1">
                          <button
                            type="button"
                            disabled={loading}
                            className="btn btn-danger "
                            onClick={() => { setEditPartnerShow(false); resetEdit(); setPartnerDetails([]); }}
                          >
                            Close
                          </button>
                          <button type="submit" disabled={loading} className="btn btn-success" >
                            {loading ? (
                              <>
                                <FaSpinner className="fa-spin mb-1" />
                              </>
                            ) : (
                              <>
                                Save
                              </>
                            )}
                          </button>
                        </div>
                      </div>

                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div >
        )}

      </CommonContainer >
      {/* </div>
      </CommonContainer > */}
      {
        partnerUserModal && (
          <MHL_PartnerUserModalComponent handleNewPartnerUserClose={handleNewPartnerUserClose} selectedPartnerDet={selectedPartnerDet} />
        )
      }

      {
        partnerDocumentModal && (
          <MHL_DocumentModalComponent handleNewDocumentModalClose={handleNewDocumentModalClose} selectedPartnerDet={selectedPartnerDet} />
        )
      }

      {showRightPanel && (
        <CommonRightPanel
          isOpen={showRightPanel}
          onClose={() => setShowRightPanel(false)}
          data={staffLoginHistory}
        />
      )}

      {showConfirmationModal && (
        <CommonConfirmationModal
          modalLoader={modalLoader}
          setShowConfirmationModal={setShowConfirmationModal}
          description={
            selectedPartnerForToggle?.Isactive
              ? "Do you want to deactivate this partner?"
              : "Do you want to activate this partner?"
          }
          onConfirm={handleConfirmToggle}
        />
      )}
    </>
  );
};

export default PartnerListComponent;